<template>
  <div>
    <base-header class="header pb-3 py-5 pt-md-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
    </base-header>
    <div class="container-fluid mt--5">
      <div
        class="
          col-xl-6
          offset-xl-2
          col-xl-8 col-lg-12
          mb-4
          card
          vld-parent
          px-2
        "
        ref="news_feed"
      >
        <p class="mb-1 mt-2">
          <img
            width="30"
            height="30"
            v-if="this.profilePicture"
            :src="profilePicture"
            class="rounded-circle"
            alt="foto de perfil"
          />
          <i v-else class="fas fa-user-circle user-default-logo"></i>
          <span class="ml-2">{{
            news.author.collaborator
              ? news.author.collaborator.name
              : news.author.company.brand_name
          }}</span>
        </p>
        <img
          v-if="news.image_url"
          class="image-feed rounded"
          :src="news.image_url"
          alt="..."
        />
        <quill-editor
          v-model="news.body"
          :options="editorReadOnly"
          disabled="disabled"
        >
        </quill-editor>
        <div class="m-3 d-flex">
          <base-button
            disabled
            class="btn btn-white"
            :title="!news.liked ? 'A empresa não pode curtir' : 'Descurtir'"
          >
            <div v-if="!news.liked" class="">
              <i class="far fa-heart fa-sm"></i>
              {{ news.likes }}
            </div>
            <div v-else class="">
              <i class="fas fa-heart fa-sm"></i>
              {{ news.likes }}
            </div>
          </base-button>
          <base-button class="btn btn-white" disabled>
            <i class="far fa-comment fa-sm"></i>
            {{ news.comments.length }}
          </base-button>
          <base-button
            v-tooltip="
              news.status === 'public'
                ? 'Oculte uma publicação que pode não estar de acordo.'
                : 'Deixar publicação visível novamente.'
            "
            class="btn btn-white"
            @click="handleSetStatus()"
          >
            <i v-if="news.status === 'public'" class="far fa-eye-slash"></i>
            <i v-else class="far fa-eye"></i>
          </base-button>
        </div>
        <hr />

        <h2>Comentários</h2>
        <div v-if="!this.news.comments.length">
          <p class="description mb-3">
            Ninguém comentou ainda! Seja o primeiro a comentar.
          </p>
        </div>
        <div
          ref="news_table"
          :key="index"
          v-for="(comment, index) in news.comments"
        >
          <div class="mb-0">
            <p class="mb-1 mt-2">
              <img
                width="30"
                height="30"
                v-if="validImageComments(comment)"
                :src="imageComments(comment)"
                class="rounded-circle"
                alt="foto de perfil"
              />
              <i v-else class="fas fa-user-circle user-default-logo"></i>
              <span class="ml-2">{{
                comment.authorCollaborator
                  ? comment.authorCollaborator.name
                  : comment.authorCompany.company_name
              }}</span>
            </p>
            <i class="far fa-comment ml-2 mr-1"></i>
            {{ comment.comment
            }}<i
              @click="handleOpenModalConfirmation(comment.id)"
              v-tooltip="'Excluir comentário!'"
              class="far fa-trash-alt float-right ml-1 text-warning"
            ></i>
          </div>
          <div
            class="mx-3"
            :key="index"
            v-for="(reply, index) in comment.replies"
          >
            <div class="mb-0">
              <p class="mb-1 mt-2">
                <img
                  width="30"
                  height="30"
                  v-if="validImageComments(reply)"
                  :src="imageComments(reply)"
                  class="rounded-circle"
                  alt="foto de perfil"
                />
                <i v-else class="fas fa-user-circle user-default-logo"></i>
                <span class="ml-2">{{
                  reply.authorCollaborator
                    ? reply.authorCollaborator.name
                    : reply.authorCompany.company_name
                }}</span>
              </p>
              <i class="far fa-comments ml-3 mr-1"></i>
              {{ reply.comment
              }}<i
                @click="handleOpenModalConfirmation(reply.id)"
                v-tooltip="'Excluir comentário!'"
                class="far fa-trash-alt float-right ml-1 text-warning"
              ></i>
            </div>
          </div>
          <span
            @click="handleResponse(comment)"
            class="mb-3 ml-2 text-blue cursor-pointer"
            >Responder</span
          >
          <hr />
        </div>
        <b>Comentar</b>
        <div v-if="commentResponse" class="row">
          <div class="col-12">
            <span class="description"
              >Respondendo a "{{ commentResponse }}"</span
            >
            <i
              class="float-right text-red fas fa-times"
              v-tooltip="'Remover seleção'"
              @click="handleResponseRemove"
            >
            </i>
          </div>
        </div>
        <base-input
          placeholder="Escreva seu comentário"
          v-model="model.newComment"
        ></base-input>
        <div class="text-right mb-3">
          <base-button
            v-if="commentResponse"
            @click="handleCommentResponse(commentResponseId)"
            class="btn"
            :disabled="loaderComment"
            >Publicar</base-button
          >
          <base-button
            v-else
            :disabled="loaderComment"
            @click="handleComment"
            class="btn"
            >Publicar</base-button
          >
        </div>
      </div>
    </div>
    <modal
      :show.sync="modal.modalConfirmation"
      modal-classes="modal-default modal-dialog-centered"
      body-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="py-3 text-center">
          <i class="fa fa-trash fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja excluir o comentário?
          </h4>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modal.modalConfirmation = false"
        >
          Voltar
        </base-button>
        <base-button
          type="white text-danger"
          @click="handleDeleteComment(idDelete)"
        >
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import api from "@/services/api";

export default {
  name: "post_card",
  components: {
    quillEditor
  },
  data() {
    return {
      news: {
        author: {
          collaborator: {
            name: "",
            profilePicture: {
              url: ""
            }
          },
          company: {
            brand_name: "",
            profilePicture: {
              url: ""
            }
          }
        },
        comments: []
      },
      loaderComment: false,
      limit: 10,
      empty: {
        news: ""
      },
      profilePicture: "",
      commentResponse: "",
      commentResponseId: "",
      model: { newComment: "" },
      editorReadOnly: {
        placeholder: "...",
        readOnly: true,
        theme: "bubble"
      },
      modal: {
        modalConfirmation: false
      },
      idDelete: 0
    };
  },
  async mounted() {
    this.loadNews(`&limit=${this.limit}`);
  },
  methods: {
    async handleSetStatus() {
      let oldStatus = this.news.status;
      this.news.status = this.news.status === "public" ? "hidden" : "public";
      try {
        await api.patch(`/company/news/${this.news.id}/set-status`, {
          status: this.news.status
        });
      } catch (error) {
        this.news.status = oldStatus;
        this.$toasted.error("Falha ao ocultar a publicação");
      }
    },
    handleResponseRemove() {
      this.commentResponse = "";
      this.commentResponseId = "";
    },
    handleResponse(comment) {
      this.commentResponse = comment.comment;
      this.commentResponseId = comment.id;
    },
    validImageComments(comment) {
      if (comment.authorCollaborator) {
        return comment.authorCollaborator.profilePicture ? true : false;
      } else if (comment.authorCompany) {
        return comment.authorCompany.profilePicture ? true : false;
      }
    },
    imageComments(comment) {
      if (comment.authorCollaborator) {
        return comment.authorCollaborator.profilePicture.url
          ? comment.authorCollaborator.profilePicture.url
          : "";
      } else if (comment.authorCompany) {
        return comment.authorCompany.profilePicture.url
          ? comment.authorCompany.profilePicture.url
          : "";
      }
    },
    handleOpenModalConfirmation(id) {
      this.modal.modalConfirmation = true;
      this.idDelete = id;
    },
    async handleDeleteComment(id) {
      try {
        await api.delete(`/company/news/${this.news.id}/comment/${id}`);
        this.modal.modalConfirmation = false;
        this.loadNews();
      } catch (error) {
        this.$toasted.error("Ocorreu um erro ao excluir o comentário!");
      }
    },
    async handleCommentResponse(id) {
      this.loaderComment = true;
      try {
        await api.post(`/company/news/${this.news.id}/comment`, {
          comment: this.model.newComment,
          reply_to: id
        });
        this.model.newComment = "";
        this.loadNews();
        this.commentResponse = "";
        this.commentResponseId = "";
        this.loaderComment = false;
        this.$toasted.show("Comentário realizado com sucesso");
      } catch (e) {
        this.loaderComment = false;
        const genericError = "Ocorreu um erro ao comentar!";
        const hasErrorResponseData = e.response && e.response.data;
        let customError = genericError;
        if (hasErrorResponseData) {
          const data = e.response.data.error
            ? e.response.data.error
            : e.response.data.errors;
          if (data[0] && data[0].message) customError = data[0].message;
          else if (data.message) customError = data.message;
        }
        this.$toasted.error(hasErrorResponseData ? customError : genericError);
      }
    },
    async handleComment() {
      this.loaderComment = true;
      try {
        await api.post(`/company/news/${this.news.id}/comment`, {
          comment: this.model.newComment
        });
        this.model.newComment = "";
        this.loadNews();
        this.loaderComment = false;
        this.$toasted.show("Comentário realizado com sucesso");
      } catch (e) {
        this.loaderComment = false;
        const genericError = "Ocorreu um erro ao comentar!";
        const hasErrorResponseData = e.response && e.response.data;
        let customError = genericError;
        if (hasErrorResponseData) {
          const data = e.response.data.error
            ? e.response.data.error
            : e.response.data.errors;
          if (data[0] && data[0].message) customError = data[0].message;
          else if (data.message) customError = data.message;
        }
        this.$toasted.error(hasErrorResponseData ? customError : genericError);
      }
    },
    truncate(text, stop = 150, clamp = "...") {
      if (!text) return "N/A";
      return text.slice(0, stop) + (stop < text.length ? clamp : "");
    },
    async loadPublications(targetObjName, loaderRef, errorMsg) {
      this.empty[targetObjName] = false;
      const loader = this.$loading.show({
        container: loaderRef,
        width: 90,
        height: 90
      });
      try {
        const { data } = await api.get(
          `/company/news/${this.$route.params.id}`
        );
        if (data) {
          this.news = data;
          if (this.news.author.collaborator) {
            this.profilePicture = this.news.author.collaborator.profilePicture
              ? this.news.author.collaborator.profilePicture.url
              : "";
          } else if (this.news.author.company) {
            this.profilePicture = this.news.author.company.profilePicture
              ? this.news.author.company.profilePicture.url
              : "";
          }
        } else this.empty[targetObjName] = true;
        loader.hide();
      } catch (e) {
        this.$toasted.error(`Ocorreu um erro ao recuperar ${errorMsg}`);
      }
    },
    async loadNews() {
      await this.loadPublications(
        "news",
        this.$refs.news_table,
        "as publicações"
      );
    }
  }
};
</script>
<style scoped>
.card-image {
  width: 115px;
  height: 115px;
  border-radius: 10%;
  margin: auto;
}
.fab {
  color: #f6f9fc;
}
</style>
<style>
.nv-container-read-only .quill-editor .ql-container,
.nv-container-read-only .quill-editor .ql-container .ql-editor {
  min-height: 5rem;
  max-height: 10rem;
  width: 100%;
}

p > strong {
  font-weight: bold !important;
}
</style>
<style scoped>
.image-feed {
  max-width: 500;
  max-height: 500;
}
.user-default-logo {
  font-size: 30px;
  vertical-align: middle;
}
</style>
